import { createContext, useEffect, useContext } from "react";

import { UserContext } from "./user.context";
import useVendors from "../hooks/vendors/useVendors.vendor.hook";

export const VendorsContext = createContext({
  vendors: [],
  setVendors: () => {},
});

export const VendorsProvider = ({ children }) => {
  const { getVendors, vendors } = useVendors();
  const { user } = useContext(UserContext);
  useEffect(() => {
    if (!user?._id || vendors?.length !== 0) return;
    getVendors();
  }, [user]);

  return (
    <VendorsContext.Provider value={{ vendors }}>
      {children}
    </VendorsContext.Provider>
  );
};
